
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {channelGroups as groups} from '@divvit/common-channels'
import classnames from 'classnames'

export default class ChannelGroupTitle extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    noIcon: PropTypes.bool,
    className: PropTypes.string
  }

  render() {
    const {id, noIcon, className} = this.props
    const channelGroup = groups[id] || {}
    const classNames = classnames('channel-group-title', {
      [`is-${id}`]: channelGroup,
      'is-icon': !noIcon
    }, className)

    return (
      <div className={classNames}>{channelGroup.label}</div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/ChannelGroupTitle/index.js